import axios from "@/plugins/vuex/axios";

export default function (url, data, mutationName, context) {
    return new Promise((resolve, reject) => {
        axios
            .patch(url, data)
            .then((response) => {
                console.log(response)

                context.commit(mutationName, response.data)
                resolve()
            })
            .catch((e) => {
                reject(e)
            })
    })
}